import {SingleEvent} from '../components/interfaces'
import {LinkObject} from '../components/common'

export const buildFestivalLink = (singleEvent: SingleEvent): LinkObject | null => {
    const { attributes_nat: { fest } } = singleEvent
    if (fest) {
        return {
            url: fest.internalurl,
            text: fest.name_nat,
            time: null,
        }
    }
    return null
}
